import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

// Pages a signed-out investor must be able to stay on: the start-up session check answers 401 for them.
const SIGNED_OUT_PAGES = ['/username', '/password'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private location: Location,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cloned = req.clone({
      withCredentials: true,
    });

    return next.handle(cloned).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !req.url.includes('auth/login') && !this.isOnSignedOutPage()) {
          this.authService.logout();
          const returnUrl = this.router.url;
          if (returnUrl && returnUrl !== '/login') {
            this.router.navigate(['/login'], { queryParams: { returnUrl } });
          }
        }
        return throwError(() => error);
      }),
    );
  }

  private isOnSignedOutPage(): boolean {
    return SIGNED_OUT_PAGES.includes(this.location.path().split('?')[0]);
  }
}
